import type { DateRangeFilter, RangeFilter } from "../../../api_utils/types";
import { humanDateFormat } from "../../../helper_functions/utils";

export function moreThanLessThanLabel(value: RangeFilter<string | number>, label: string, prefix?: string, suffix?: string): string {
  return (
    (value.more_than || value.less_than) &&
    `${label} ${[
      value.more_than ? `more than ${prefix || ""}${value.more_than}${suffix || ""}` : false,
      value.less_than ? `less than ${prefix || ""}${value.less_than}${suffix || ""}` : false,
    ]
      .filter(Boolean)
      .join(" and ")}`
  );
};

export const dateLabel = (value: DateRangeFilter, label: string): string => {
  return `${label} ${[
    value.start ? `from ${humanDateFormat(value.start)}` : false,
    value.end ? `to ${humanDateFormat(value.end)}` : false,
  ].filter(Boolean).join(' ')}`;
};

const truncateLabelPart = (value: string, maxLength: number): string => {
  if (value.length <= maxLength) return value;
  return `${value.slice(0, maxLength - 1)}…`;
};

export const horseVariantFilterLabel = (
  title?: string,
  variantTitle?: string,
  titleMaxLength = 25,
  variantTitleMaxLength = 25,
  combinedMaxLength = 60,
): string | undefined => {
  const titlePart = title ? truncateLabelPart(title, titleMaxLength) : undefined;
  const variantTitlePart = variantTitle ? truncateLabelPart(variantTitle, variantTitleMaxLength) : undefined;
  const combinedLabel = [titlePart, variantTitlePart].filter(Boolean).join(" - ");
  if (!combinedLabel) return undefined;
  return truncateLabelPart(combinedLabel, combinedMaxLength);
};
